import { cn } from '~/lib/cn';

export function getNavLinkClassName(
  { isActive }: { isActive: boolean } = { isActive: false },
) {
  return cn(
    'flex items-center gap-xs !border-b-2xs pb-xs duration-300 ease-out border-transparent hover:text-default',
    {
      'border-b-primary-default text-default': isActive,
    },
  );
}
